import { createContext, useContext } from "react"

import { SessionContextValue } from "./session-context-types"

export const SessionContext = createContext<SessionContextValue | null>(null)

export const useSession = () => {
  const context = useContext(SessionContext)
  if (!context) {
    throw new Error("useSession must be used within SessionProvider")
  }
  return context
}
